var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.054 30c7.732 0 14-6.268 14-14s-6.268-14-14-14A13.957 13.957 0 0 0 4.09 6.165L6.936 8.88a10.04 10.04 0 0 1 7.214-3.044c5.56 0 10.069 4.507 10.069 10.068-.001 5.56-4.51 10.069-10.07 10.069a10.04 10.04 0 0 1-7.3-3.135L4 25.742A13.96 13.96 0 0 0 14.054 30zM13 20.507v-9.014c-.736.064-2.417.671-3.26 2.59-1.056 2.396 0 4.027.67 4.89.537.69 1.95 1.31 2.59 1.534zm4.903-8.387 2.632-2.793A9.3 9.3 0 1 0 23.26 16h-6.712l2.317 2.317a5.466 5.466 0 1 1-.961-6.196z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDg);
export default __webpack_public_path__ + "static/media/DG.35e4967ea2a45e0018292fd46646ff6b.svg";
export { ForwardRef as ReactComponent };